import DataGrid from "./common/DataGrid";


const Company = () => {
return (
    <div style={{ height: '80vh' }}>
<DataGrid
  columnDefs={[{ field: 'company_name' ,width : 250 }, { field: 'company_gst' },{field : 'company_pincode'},{field : 'company_address',width : 650 }]}
  apiEndpoint="https://oms-be.shreetradingcompany.in/api/all-company"
  height="80vh"
/>
</div>
)
}

export default Company;